

export const columns = [
    {
        type: 'index',
        width: 65,
        title: '序号'
    },
    {
        title: '登录账号',
        key: 'userName',
        minWidth: 120,
        // maxWidth: 120,
        show: true
    },
    {
        title: '用户',
        slot: 'name',
        minWidth: 160,
        maxWidth: 160,
        show: true
    },
    {
        title: '角色',
        slot: 'roleName',
        minWidth: 120,
        maxWidth: 120,
        show: true
    },
    {
        title: '所在部门',
        slot: 'departmentName',
        minWidth: 160,
        maxWidth: 160,
        show: true
    },
    {
        title: '手机号',
        key: 'phone',
        minWidth: 115,
        maxWidth: 115,
        show: true
    },
    {
        title: '邮箱',
        key: 'email',
        minWidth: 180,
        maxWidth: 180,
        show: true
    },
    {
        title: '性别',
        slot: 'gender',
        minWidth: 90,
        maxWidth: 95,
        align:'center',
        show: true
    },
    {
        title: '状态',
        slot: 'isDeleted',
        minWidth: 100,
        maxWidth: 100,
        show: true
    },
    {
        title: '创建时间',
        slot: 'createdTime',
        minWidth: 180,
        maxWidth: 180,
        show: true
    },
    {
        title: '操作',
        slot: 'action',
        minWidth: 145,
        maxWidth: 145,
        show: true
    },
]

